<div *ngIf="params['utm_source'] === 'external_stories_otd_calling' && (params?.birthdaytime !== '1' || !params.mini_story.match('1'))" class="nudge">
  <div class="text">You just spoke to <strong>{{caller_name}}</strong> and they believe you can save {{fundraiser?.beneficiaryname?.info_1}}. Make your donation today.</div>
</div>
<div *ngIf="params?.birthdaytime === '1' && params?.mini_story === '1'" class="bdaynudge">
  <div class="text">Hey, <strong>{{caller_name}}</strong> from Ketto has sent you this story. ❤️</div>
</div>
<div class="mini-story-wrapper">
  <!-- <div class="header">
    <app-contact-beneficiary [fundraiser]="fundraiser"></app-contact-beneficiary>

    <app-ketto-assured-v2 theme="theme_v2"></app-ketto-assured-v2>
  </div> -->
  <div class="title">{{fundraiser?.title}}</div>

  <div class="banner">
    <app-tax-benefit-nudge *ngIf="fundraiser?.beneficiary?.tax_benefit && vwo.tickr_mini_story_AB()"></app-tax-benefit-nudge>
    <img [attr.data-src]="getTheaterImg()" [default]="util.defaultImg" alt="">
  </div>

  <!-- <div class="beneficiary-details">
    <div>
      <div class="b-title">Patient Name</div>
      <div class="name" [title]="fundraiser?.beneficiaryname?.info_1">{{fundraiser?.beneficiaryname?.info_1}}</div>
    </div>
    <div>
      <div class="b-title">Hospital Name</div>
      <div class="name" [title]="fundraiser?.hospital_only?.info_1">{{fundraiser?.hospital_only?.info_1}}</div>
    </div>
  </div> -->

  <div class="see-more" *ngIf="params?.mini_story !== '2'">
    <button mat-button href="https://www.google.com/" color="primary" (click)="viewMore.emit(false)">
      <span>View Story</span>
      <i class="material-icons">chevron_right</i>
    </button>
  </div>
</div>

<div *ngIf="fundraiser" class="payment-wrapper">
  <app-story-payment [config]="{
      fundraiser: fundraiser, supporters: false, daysLeft: false, paymentHeader: false, position: 26,
      assured: false, header: false, mini_story: true, theme: params?.birthdaytime === '1' && params?.mini_story === '1' ? 'v2':'v1'
    }">
  </app-story-payment>
</div>

<div *ngIf="vwo.tickr_mini_story_AB() && !isFundraiserEnded" class="tickr">
  <app-tickr [skipSipTicker]="true" [theme]="'v1'"></app-tickr>
</div>